export const iconFontAwesomeMapsSuitcaseMedical = (
	<i className="fa-solid fa-suitcase-medical"></i>
);
